module.exports = __webpack_public_path__ + "static/img/videG.17da77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videG.jpg
// module id = HOFN
// module chunks = 0